import { queryOptions } from "@tanstack/react-query";
import { apiGet } from "../client";
import type { Paged, Store } from "../types";
import { qk } from "./qk";

export const studioStoresQuery = (limit = 4) =>
  queryOptions({
    // Under qk.stores.all(), so a session change resets it with the other viewer-relative store queries.
    queryKey: qk.stores.studio(limit),
    // The endpoint pages like every other catalog list; this row only wants the items.
    queryFn: async () => (await apiGet<Paged<Store>>(`/api/stores?kind=studio&pageSize=${limit}`)).items,
    staleTime: 120_000,
  });
